const s = {
  name: "UserPlus",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 40" style="enable-background:new 0 0 35 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.4-3.6,8-8,8S10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S21.3,2,18,2z"/>
		<path class="st0" d="M0,29c0-6.1,4.9-11,11-11h15v2H11c-5,0-9,4-9,9v11H0V29z"/>
		<path class="st0" d="M6,30v10h2V30H6z"/>
		<path class="st0" d="M29,34v-4h2v4h4v2h-4v4h-2v-4h-4v-2H29z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserPlus
};
